import React from 'react'
import { Link } from 'react-router-dom'

export default function Valncia() {
  return <>
    <div className="container-fluid bg-primary py-5 bg-prd16 mb-5">
      <div className="container py-5">
        <div className="row justify-content-start">
          <div className="col-lg-8 text-center text-lg-start">
            <h1 className="display-1 text-white mb-md-4">Valencia Orange</h1>
            <Link to="/fresh-products" className="btn btn-primary py-md-3 px-md-5 me-3">fresh products </Link>
            <Link to="" className="btn btn-secondary py-md-3 px-md-5">Valencia Orange</Link>
          </div>
        </div>
      </div>
    </div>


    <div className="container ">
      <div className='mb-5'>
        <h2 className='text-primary'> Taste </h2>
        <h5 className='text-muted'>Valencia oranges are prized for their delicious taste, which is a result of their unique
          combination of high acid and high sugar content. The high acid content gives them
          a tangy and refreshing flavor, while the high sugar content adds sweetness. This
          balance of flavors makes them an excellent choice for juicing. The juice extracted
          from Valencia oranges is often described as sweet, aromatic, and flavorful
        </h5>
      </div>
      <h2 className='text-primary my-3'>Valencia Orange:</h2>

      <ul className='mb-5'>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>Has a thin peel and a sweet flavor, preferred for fresh juice</h5>
        </li>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>Culinary Uses: Consumed fresh as a delicious fruit.</h5>
        </li>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>Used in preparing fresh juices and desserts. </h5>
        </li>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>Added to fruit salads and seafood dishes</h5>
        </li>

      </ul>
      <hr />
      <hr />



      <hr />
      <h2 className='text-primary my-3'>Season:</h2>

      <ul className='mb-5'>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>-In Egypt, the Valencia orange seasons typically run from December to May</h5>
        </li>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>-In Brazil, the Valencia orange season typically runs from June to September.</h5>
        </li>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>-In the United States, Valencia oranges are usually harvested from February to June.</h5>
        </li>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>-In Morocco, the Valencia orange season can be from December to June.</h5>
        </li>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>-In Tunisia, the Valencia orange season is typically from February to July.</h5>
        </li>

      </ul>
      <hr />

      <hr />
      <h2 className='text-primary my-3'>Packing:</h2>

      <ul className='mb-5'>

        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>Telescopic carton or open top carton
          </h5>
        </li>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>In bins (600 kgs ).          </h5>
        </li>


      </ul>
      <hr />
      <hr />
      <div className='my-5'>
        <i className="me-3  text-success  fa-regular fa-circle-check"></i>
        <h5 className=' d-inline mb-3'>Size:</h5>
        <h5 className=' mt-3'> (40-48-56-64-72-80-88-100-113-125)</h5>
      </div>
      <hr />
      <hr />
      <Link to="/contact" className="btn bg-primary text-light py-3 px-5">Get Offer</Link>

    </div>
  </>
}
